import React, { useState, useEffect } from 'react'
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem, CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DataTable from "../components/DataTable";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import SnackbarAlert from "../components/SnackbarAlert";
export default function Plans() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [planCategory, setPlanCategory] = useState([]);
    const [editState, setEditState] = useState(null);
    const [open, setOpen] = useState(false);
    const [categoryId, setCategoryId] = useState();
    const [planName, setPlanName] = useState();
    const [planAmount, setPlanAmount] = useState();
    const [planDuration, setPlanDuration] = useState();
    const [planDurationType, setPlanDurationType] = useState();
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    useEffect(() => {
        fetchPlanData();
    }, []);
    const fetchPlanData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "plans";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "plancategory";
            const response = await makeRequest("get", url);
            if (response) {
                setPlanCategory(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAdd = () => {
        setEditState(null);
        setPlanName("");
        setCategoryId("");
        setPlanAmount("");
        setPlanDuration("");
        setPlanDurationType("");
        setOpen(true);
    };
    const openEdit = (data) => {
        setEditState(data);
        setPlanName(data?.saving_plan_name);
        setCategoryId(data?.plan_category_id);
        setPlanAmount(data?.plan_starting_amount);
        setPlanDuration(data?.plan_duration);
        setPlanDurationType(data?.plan_type);
        setOpen(true);
    };
    const handleSave = async () => {
        if (!planName && !planCategory && !planAmount && !planDuration && !planDurationType) {
            setMessage("All Fileds are Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const categoryEditData = {
                    plan_category_id: categoryId,
                    saving_plan_name: planName,
                    plan_starting_amount: planAmount,
                    plan_duration: planDuration,
                    plan_type: planDurationType
                };
                try {
                    let url = webEndPoint + "plans/" + editState.rfId;
                    const response = await makeRequest("put", url, categoryEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Plan Updated Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            } else {
                const categoryAddData = {
                    plan_category_id: categoryId,
                    saving_plan_name: planName,
                    plan_starting_amount: planAmount,
                    plan_duration: planDuration,
                    plan_type: planDurationType
                };
                try {
                    let url = webEndPoint + "plans";
                    const response = await makeRequest("post", url, categoryAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("Plange Added Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }
            setDataSource([]);
            fetchPlanData();
            setSnackbar(true);
            setOpen(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const columns = ["S.No", "Category", "Plan Name", "Amount", "Plan Type", "Duration", "Action"];
    const rows = dataSource.map((p, i) => [i + 1, p.plan_name, p.saving_plan_name, p.plan_starting_amount, p.plan_type, `${p.plan_duration} ${p.plan_type === "MONTHLY" ? "Months" : "Weeks"}`,
    <Box>
        <Tooltip title="Edit">
            <IconButton onClick={() => openEdit(p)} color="primary">
                <EditIcon />
            </IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Savings Plan</Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAdd}>Add Plan</Button>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            {open && (
                <Box component="div" sx={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 1000 }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>{editState !== null ? "Edit Plan" : "Add Plan"}</Typography>
                        <TextField select label="Plan Category" name="category" fullWidth value={categoryId} onChange={(e) => setCategoryId(e.target.value)} sx={{ mb: 2 }}>
                            {planCategory?.map((cat) => (<MenuItem key={cat?.rfId} value={cat?.rfId}>{cat?.plan_name}</MenuItem>))}</TextField>
                        <TextField label="Plan Name" fullWidth value={planName} onChange={(e) => setPlanName(e.target.value)} sx={{ mb: 2 }} />
                        <TextField label="Plan Minimum Amount" fullWidth value={planAmount} onChange={(e) => setPlanAmount(e.target.value)} sx={{ mb: 2 }} />
                        <TextField select label="Plan Type" name="type" fullWidth value={planDurationType} onChange={(e) => setPlanDurationType(e.target.value)} sx={{ mb: 2 }}>
                            <MenuItem value="Day">Day</MenuItem>
                            <MenuItem value="WEEKLY">Weeks</MenuItem>
                            <MenuItem value="MONTHLY">Months</MenuItem>
                        </TextField>
                        <TextField label="Plan Duration" fullWidth value={planDuration} onChange={(e) => setPlanDuration(e.target.value)} sx={{ mb: 2 }} />
                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                            <Button onClick={() => setOpen(false)}>Cancel</Button>
                            <Button variant="contained" onClick={handleSave}>Save</Button>
                        </Box>
                    </Box>
                </Box>
            )}
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}